import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';

import { MatIcon } from '@angular/material/icon';

import { VisitsService } from '@hm/core/services/visits.service';

import { formatDate } from '@lib/commons/util-functions/format-date.function';

import { DrEleksVisit } from '@lib/core/models/dobrobut-entities.interface';

@Component({
  selector: 'hm-eleks-visit',
  standalone: true,
  imports: [MatIcon, DatePipe, NgClass],
  templateUrl: './eleks-visit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EleksVisitComponent {
  private readonly visitsService = inject(VisitsService);

  protected readonly formatDate = formatDate;

  eleksVisitData = input.required<DrEleksVisit>();

  protected selected = signal<boolean>(false);

  protected selectEleksVisit(select: boolean) {
    if (select) {
      this.selected.set(true);
      this.visitsService.selectedEleksVisit$.next(this.eleksVisitData());
    } else {
      this.selected.set(false);
      this.visitsService.selectedEleksVisit$.next(null);
    }
  }
}
